import {CapsulableEntity, EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";
import {Box, Stack, useTheme} from "@mui/joy";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCameraRetro} from "@fortawesome/pro-regular-svg-icons";


export interface BundleCapsuleProps extends Omit<EntityCapsuleProps, "entity"> {
    bundle: CapsulableEntity;
    photoRequired?: boolean;
}

export function BundleCapsule(props: BundleCapsuleProps) {
    const {bundle, photoRequired, ...rest} = props;
    const theme = useTheme();
    if (!bundle.icon) {
        bundle.icon = iconForEntityType("bundle");
    }
    return <Stack direction="row" sx={{alignItems: "center"}}>
        <EntityCapsule entity={bundle} {...rest}/>
        {photoRequired
            ? <Box sx={{pl: 0.8, color: theme.palette.primary[700]}}><FontAwesomeIcon icon={faCameraRetro}/></Box>
            : null}
    </Stack>
    // return linkify && bundle.id
    //     ? <RouterJoyLink to="/bundle/$id/cargo" params={{id: bundle.id}}
    //                      underline="hover">{capsule}</RouterJoyLink>
    //     : capsule;
}

// export interface CapsulableBundle {
//     id: string;
//     icon?: FontAwesomeIconProps;
// }
//
// export interface ActiveBundleCapsuleProps extends Omit<SheetProps, "children"> {
//     bundle: CapsulableBundle;
//     linkify?: boolean;
//     details?: BundleCapsuleDetails;
// }
//
// export function BundleTile(props: ActiveBundleCapsuleProps) {
//     const {
//         bundle: inBundleStub,
//         linkify,
//         details,
//         ...rest
//     } = props;
//     const {id: bundleId} = inBundleStub;
//     const mama = useMothership();
//     const {data: bundleData, isSuccess: isBundleSuccess}
//         = useQuery(peekBundleByIdTqo(mama, {bundleId}));
//     const enabled = isBundleSuccess;
//     const bundle = bundleData?.bundle;
//     const icon = inBundleStub.icon ?? iconForEntityType("bundle");
//     const {data: status, isSuccess: isStatusSuccess}
//         = useBundleStatus({bundleId});
//     const {data: lastTransferData}
//         = useRefreshableQuery(watchLastTransferForBundleTqo(mama, {bundleId}));
//     const lastTransfer = lastTransferData?.transfer;
//     const {data: jobData, isSuccess: isJobSuccess}
//         = useQuery({
//         ...peekJobByIdTqo(mama, {jobId: bundle?.job.id ?? TQDEADBEEF}),
//         enabled,
//     });
//     const job = jobData?.job;
//     const theme = useTheme();
//     const variant = inVariant ?? "plain";
//     const underVariant = variant === "outlined" ? "plain" : variant;
//     const {fgColor, bgColor} = figureColors({
//         theme, color: props.color, variant: props.variant, invertedColors: props.invertedColors
//     });
//     const restSx = isFunction(rest.sx) ? rest.sx(theme) : rest.sx;
//     // eslint-disable-next-line @typescript-eslint/no-misused-spread
//     const topSx = {...restSx, fontSize: theme.fontSize.xl};
//     // eslint-disable-next-line @typescript-eslint/no-misused-spread
//     const lowSx = {...restSx, fontSize: theme.fontSize.md};
//
//     if (!isBundleSuccess || !isJobSuccess || !bundle || !isStatusSuccess) {
//         return null;
//     }
//
//     const capsuleFood: CapsulableEntity = {...bundle, icon};
//     return <Tile variant={variant} color={props.color} Subject={() =>
//         <>{linkify
//             ? <RouterJoyLink to={bundleRoute.to} params={{id: bundle.id}} underline="hover">
//                 <EntityCapsule entity={capsuleFood}/>
//             </RouterJoyLink>
//             : <EntityCapsule entity={capsuleFood}/>}
//             {details?.photoRequired
//                 ? <Box sx={{pl: 0.8, color: theme.palette.primary[700]}}><FontAwesomeIcon icon={faCameraRetro}/></Box>
//                 : null}
//         </>}>
//         {job && details?.sendCompany
//             ? <CompanyCapsule company={job.sendCompany} sx={lowSx}/>
//             : null}
//         {details?.pickupPlace ?? details?.dropoffVenue
//             ? <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
//                 {details.pickupPlace
//                     ? <> {bundle.origin.venue
//                         ? <VenueCapsule venue={bundle.origin.venue} sx={lowSx}/>
//                         : <TruckCapsule truck={bundle.origin.truck}  sx={lowSx} linkify={linkify}/>}
//                         <FontAwesomeIcon icon={faArrowRight} color={fgColor}/>
//                     </>
//                     : null}
//             </Stack>
//             : null}
//         {bundle.destination && details?.dropoffVenue
//             ? <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
//                 <FontAwesomeIcon icon={faArrowRight} color={fgColor}/>
//                 <VenueCapsule venue={bundle.destination} variant={underVariant}
//                               {...rest} sx={lowSx}/>
//             </Stack>
//             : null}
//         {details?.lastTruck && lastTransfer?.truck
//             ? <TruckCapsule truck={lastTransfer.truck} {...rest} sx={lowSx}/>
//             : null}
//         {details?.status
//             ? <Box sx={{fontSize: "lg", mt: 1}}>{status.label}</Box>
//             : null}
//     </Tile>;
// }

//     </Tile>
//     <Card variant={variant} {...rest}>
//         <CardContent>
//             <Stack direction="column" spacing={0.4}
//                    sx={{alignItems: "left", bgcolor: bgColor}}>
//                 <Box sx={{pb: 1.2, width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
//                     {linkify
//                         ?
//                         <RouterJoyLink to={bundleRoute.to} params={{id: bundle.id}} underline="hover">
//                             <EntityCapsule entity={capsuleFood} variant={underVariant} {...rest} sx={topSx}/>
//                         </RouterJoyLink>
//                         : <EntityCapsule entity={capsuleFood} variant={underVariant} {...rest} sx={topSx}/>}
//                     {details?.photoRequired
//                         ? <Box sx={{pl: 0.8, color: theme.palette.primary[700]}}><FontAwesomeIcon icon={faCameraRetro}/></Box>
//                         : null}
//                 </Box>
//             </Stack>
//         </CardContent>
//     </Card>
// }

